import type { StateCreator } from "zustand";
import type { AuthMethod, AuthState } from "../types/types";

export interface AuthSlice extends AuthState {
  authError: string | null;
  setAuthMethod: (method: AuthMethod) => void;
  setPlayerHash: (hash: string | null) => void;
  setToken: (token: string | null) => void;
  setAuthData: (data: Record<string, unknown> | null) => void;
  setAuthError: (error: string | null) => void;
  setAuthenticated: (authenticated: boolean) => void;
  clearAuth: () => void;
}

export const createAuthSlice: StateCreator<AuthSlice> = (set) => ({
  authMethod: null,
  playerHash: null,
  token: null,
  authData: null,
  authenticated: false,
  authError: null,

  setAuthMethod: (method) => set({ authMethod: method }),
  setPlayerHash: (hash) => set({ playerHash: hash }),
  setToken: (token) => set({ token }),
  setAuthData: (data) => set({ authData: data }),
  setAuthError: (authError) => set({ authError }),
  setAuthenticated: (authenticated) => set({ authenticated }),
  clearAuth: () =>
    set({
      authMethod: null,
      playerHash: null,
      token: null,
      authData: null,
      authError: null,
      authenticated: false,
    }),
});
